import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
interface BonusSectionProps {
  onImageClick: () => void;
}
interface BonusItem {
  label: string;
  items: string[];
}
const BONOS: BonusItem[] = [{
  label: '🎮 Bono 1 — 100 juegos de hockey infantil',
  items: ['✅ Juegos de conducción', '✅ Juegos de pase', '✅ Juegos defensivos', '✅ Coordinación y reacción', '✅ Mini desafíos y competencias divertidas']
}, {
  label: '📋 Bono 2 — 30 clases listas para usar',
  items: ['🕒 Objetivo de cada clase', '🏑 Materiales necesarios', '📚 Desarrollo completo', '🔄 Variantes y adaptaciones']
}, {
  label: '📊 Bono 3 — Planillas para profes de hockey',
  items: ['📝 Asistencia', '📈 Evolución técnica', '📅 Planificación mensual', '👦 Seguimiento individual']
}, {
  label: '🧠 Bono 4 — Guía para manejar grupos difíciles',
  items: ['⚡ Chicos dispersos', '🤝 Conflictos grupales', '👨‍👩‍👧 Manejo de padres', '🎯 Diferencias de nivel y atención']
}, {
  label: '🗺️ Bono 5 — Atlas visual de ejercicios',
  items: ['📍 Armado de cancha', '🟠 Ubicación de conos', '➡️ Desplazamientos', '🎯 Objetivos de cada ejercicio']
}];
export function BonusSection({
  onImageClick
}: BonusSectionProps) {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="py-14 px-4 bg-gradient-to-b from-brand-dark to-brand-card relative overflow-hidden" data-id="element-25">
      <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-brand-accent to-transparent opacity-50" data-id="element-26"></div>

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-27">
        <div className="text-center mb-8" data-id="element-28">
          <span className="inline-block px-4 py-1.5 bg-brand-accent/20 text-brand-accent border border-brand-accent/50 rounded-full text-sm font-bold tracking-wider uppercase mb-4" data-id="element-29">
            Oferta por tiempo limitado
          </span>
          <h2 className="text-3xl md:text-5xl font-display text-brand-cream uppercase" data-id="element-30">
            Llevate estos{' '}
            <span className="text-brand-accent" data-id="element-31">BONOS GRATIS</span> hoy
          </h2>
        </div>

        <div className="space-y-3" data-id="element-32">
          {BONOS.map((bono, index) => <div key={index} className="rounded-xl overflow-hidden border bg-brand-accent/5 border-brand-accent/40" data-id="element-33">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-5 py-4 text-left flex items-center justify-between gap-4 focus:outline-none" data-id="element-34">
                <span className="font-bold text-brand-cream text-sm md:text-base flex items-center gap-3" data-id="element-35">
                  {bono.label}
                  <span className="bg-brand-accent text-brand-dark text-[10px] font-bold px-2 py-0.5 rounded uppercase tracking-wider" data-id="element-36">
                    Gratis
                  </span>
                </span>
                <ChevronDown className={`w-5 h-5 text-brand-accent flex-shrink-0 transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-37" />
              </button>
              <AnimatePresence data-id="element-38">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-39">
                    <ul className="px-5 pb-5 pt-1 space-y-2 border-t border-white/5" data-id="element-40">
                      {bono.items.map((line, i) => <li key={i} className="text-sm text-brand-cream/80" data-id="element-41">
                          {line}
                        </li>)}
                    </ul>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}